/** Fired when purchased bit coordinates are committed so the header can update counts. */
export const COUNTRY_BITS_SOLD_EVENT = "mybitofit:country-bits-sold";

export type CountryBitsSoldDetail = {
  countryId: number;
  coordinateCount: number;
};

export function dispatchCountryBitsSold(
  countryId: number | null | undefined,
  coordinateCount: number,
): void {
  if (
    countryId == null ||
    !Number.isFinite(countryId) ||
    coordinateCount <= 0 ||
    !Number.isFinite(coordinateCount)
  ) {
    return;
  }
  window.dispatchEvent(
    new CustomEvent<CountryBitsSoldDetail>(COUNTRY_BITS_SOLD_EVENT, {
      detail: { countryId, coordinateCount },
    }),
  );
}
